// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__3sjjA","content":"styles_content__2zEwZ","checkbox":"styles_checkbox__3iyoZ","checkboxLabel":"styles_checkboxLabel__1KkVR"};